import { createSelector } from 'reselect';
import { AppState } from '../..';

const getFollowsSlice = (state: AppState) => state.follows;

export const selectSignalFollowsLoading = createSelector(
  (state: AppState) => state.follows.signalFollowsLoading,
  (loading) => loading,
);

export const selectSignalsKeyedByMember = createSelector(
  (state: AppState) => state.signal.signals,
  (signals) =>
    Object.values(signals).reduce(
      (acc, signal) => {
        acc[signal.memberid] = signal;
        return acc;
      },
      {} as { [key: string]: AppState['signal']['signals'][0] },
    ),
);

export const getAllFollowsForCurrentMemberWithSignal = createSelector(
  (state: AppState) => state.follows.follows,
  (state: AppState) => state.backendService.currentMember,
  selectSignalsKeyedByMember,
  (follows, currentMember, signalsByMemberId) => {
    if (!currentMember?.id) {
      return [];
    }

    return Object.values(follows)
      .filter((follow) => follow.follower.id === `${currentMember.id}`)
      .map((follow) => ({
        ...follow,
        followee: {
          ...follow.followee,
          signal: signalsByMemberId[follow.followee.id],
        },
      }))
      .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
  },
);

export const getAllActiveFollowsForCurrentMemberWithSignal = createSelector(
  getAllFollowsForCurrentMemberWithSignal,
  (follows) =>
    follows
      .filter((follow) => follow.followee.signal?.online)
      .filter((follow) => follow.followee.signal?.on_the_water)
      .filter((follow) => follow.followee.signal),
);

export const selectFollowInviteCode = createSelector(
  getFollowsSlice,
  (follows) => follows.invitationCode,
);
